import React from 'react'
import { Container } from '@components/Container'
import { AppLayout } from '@components/layouts/AppLayout'
import { OgShare } from '@components/OgShare'
import FaqMenu from '../components/FaqMenu'

const faqMenus = [
  { title: 'การใช้งาน', url: '/faq/how-to' },
  { title: 'ระบบเหรียญ', url: '/faq/coin' },
  { title: 'ระบบ “สนับสนุนตัวละคร”', url: '/faq/donate' },
  { title: 'การสร้างเรื่อง / ตอน ', url: '/faq/create-story' },
  { title: 'การเป็นนักเขียน', url: '/faq/writer' },
  { title: 'ติดต่อเรา', url: '/contact-us' },
]

function FaqPage({ url }: { url: string }) {
  return (
    <AppLayout>
      <OgShare url={url} />
      <Container>
        <div className='faq pb-[50px] pt-[20px] tablet-mobile:pb-[20px] tablet:px-[20px] mobile:px-[10px]'>
          <div className='text-center text-2xl font-mitr mb-[20px] dark:text-white-2'>
            คำถามที่พบบ่อย (FAQ)
          </div>
          <div className='shadow-card rounded-[8px] px-[20px] pt-[20px] flex flex-col font-mitr'>
            {faqMenus.map(menu => (
              <FaqMenu key={menu.title} {...menu} />
            ))}
          </div>
        </div>
      </Container>
    </AppLayout>
  )
}

export default FaqPage
